<template>
    <div id="summary-reservation-detail">
        <div class="fs-24px tw-text-darkGreen mb-30px">
            Make sure all your details are correct.
        </div>
        <div id="summary-reserve-property-info">
            <h3 class="tw-text-darkGreen tw-text-[20px] tw-mb-[25px]">
                Property Information
            </h3>
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="tw-flex tw-flex-col tw-justify-center tw-mb-0">
                        <label class="fs-16px fw-medium tw-text-black"
                            >Property type</label
                        >
                        <p
                            class="tw-text-[20px] tw-border-none tw-h-[52px] tw-outline-none tw-font-bold tw-text-midGreen mb-0"
                        >
                            Residential
                        </p>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="tw-flex tw-flex-col tw-justify-center tw-mb-0">
                        <label class="fs-16px fw-medium tw-text-black"
                            >Estate</label
                        >
                        <p
                            class="tw-text-[20px] tw-border-none tw-h-[52px] tw-outline-none tw-font-bold tw-text-midGreen mb-0"
                        >
                            Capitol Commons
                        </p>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="tw-flex tw-flex-col tw-justify-center tw-mb-0">
                        <label class="fs-16px fw-medium tw-text-black"
                            >Property Name</label
                        >
                        <p
                            class="tw-text-[20px] tw-border-none tw-h-[52px] tw-outline-none tw-font-bold tw-text-midGreen mb-0"
                        >
                            Maven at Capitol Commons
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <hr />
        <div id="summary-reserve-personal-info">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <h3 class="tw-text-darkGreen tw-text-[20px] tw-mb-[25px]">
                        Personal Information
                    </h3>
                    <label class="fs-16px fw-medium tw-text-black"
                        >First name</label
                    >
                    <p
                        class="tw-text-[20px] tw-border-none tw-h-[52px] tw-outline-none tw-font-bold tw-text-midGreen mb-0"
                    >
                        Elizabeth
                    </p>
                    <label class="fs-16px fw-medium tw-text-black"
                        >Middle name</label
                    >
                    <p
                        class="tw-text-[20px] tw-border-none tw-h-[52px] tw-outline-none tw-font-bold tw-text-midGreen mb-0"
                    >
                        -
                    </p>
                    <label class="fs-16px fw-medium tw-text-black"
                        >Last name</label
                    >
                    <p
                        class="tw-text-[20px] tw-border-none tw-h-[52px] tw-outline-none tw-font-bold tw-text-midGreen mb-0"
                    >
                        Estanislao
                    </p>
                    <label class="fs-16px fw-medium tw-text-black">Email</label>
                    <p
                        class="tw-text-[20px] tw-border-none tw-h-[52px] tw-outline-none tw-font-bold tw-text-midGreen mb-0"
                    >
                        eestanislao@mail.com
                    </p>
                    <label class="fs-16px fw-medium tw-text-black"
                        >Mobile Number</label
                    >
                    <p
                        class="tw-text-[20px] tw-border-none tw-h-[52px] tw-outline-none tw-font-bold tw-text-midGreen mb-0"
                    >
                        +63 912 345 6789
                    </p>
                    <label class="fs-16px fw-medium tw-text-black"
                        >Landline Number</label
                    >
                    <p
                        class="tw-text-[20px] tw-border-none tw-h-[52px] tw-outline-none tw-font-bold tw-text-midGreen mb-0"
                    >
                        02 8123 4567
                    </p>
                </div>
                <div class="col-12 col-lg-6">
                    <h3 class="tw-text-darkGreen tw-text-[20px] tw-mb-[25px]">
                        Attached Documents
                    </h3>
                    <label class="fs-16px fw-medium tw-text-black"
                        >Photo of yourself</label
                    >
                    <div
                        class="tw-flex tw-p-3 tw-mb-5"
                        style="border: 1px solid #a3a277"
                    >
                        <div
                            class="tw-w-[80%] tw-text-midGreen tw-font-bold tw-text-[20px] tw-overflow-hidden"
                        >
                            IMG_2023123123123.JPG
                        </div>
                        <div class="tw-w-[20%] tw-text-right">
                            <i class="fa fa-file"></i>
                        </div>
                    </div>
                    <label class="fs-16px fw-medium tw-text-black"
                        >Valid ID</label
                    >
                    <div
                        class="tw-flex tw-p-3 tw-mb-5"
                        style="border: 1px solid #a3a277"
                    >
                        <div
                            class="tw-w-[80%] tw-text-midGreen tw-font-bold tw-text-[20px] tw-overflow-hidden"
                        >
                            IMG_2023123123123.JPG
                        </div>
                        <div class="tw-w-[20%] tw-text-right">
                            <i class="fa fa-file"></i>
                        </div>
                    </div>
                    <label class="fs-16px fw-medium tw-text-black"
                        >Valid ID</label
                    >
                    <div
                        class="tw-flex tw-p-3 tw-mb-5"
                        style="border: 1px solid #a3a277"
                    >
                        <div
                            class="tw-w-[80%] tw-text-midGreen tw-font-bold tw-text-[20px] tw-overflow-hidden"
                        >
                            IMG_2023123123123.JPG
                        </div>
                        <div class="tw-w-[20%] tw-text-right">
                            <i class="fa fa-file"></i>
                        </div>
                    </div>
                    <label class="fs-16px fw-medium tw-text-black"
                        >Billing statement</label
                    >
                    <div
                        class="tw-flex tw-p-3 tw-mb-5"
                        style="border: 1px solid #a3a277"
                    >
                        <div
                            class="tw-w-[80%] tw-text-midGreen tw-font-bold tw-text-[20px] tw-overflow-hidden"
                        >
                            IMG_2023123123123.JPG
                        </div>
                        <div class="tw-w-[20%] tw-text-right">
                            <i class="fa fa-file"></i>
                        </div>
                    </div>
                    <label class="fs-16px fw-medium tw-text-black"
                        >Proof of income</label
                    >
                    <div
                        class="tw-flex tw-p-3 tw-mb-5"
                        style="border: 1px solid #a3a277"
                    >
                        <div
                            class="tw-w-[80%] tw-text-midGreen tw-font-bold tw-text-[20px] tw-overflow-hidden"
                        >
                            IMG_2023123123123.JPG
                        </div>
                        <div class="tw-w-[20%] tw-text-right">
                            <i class="fa fa-file"></i>
                        </div>
                    </div>
                    <label class="fs-16px fw-medium tw-text-black"
                        >Other document</label
                    >
                    <div
                        class="tw-flex tw-p-3 tw-mb-5"
                        style="border: 1px solid #a3a277"
                    >
                        <div
                            class="tw-w-[80%] tw-text-midGreen tw-font-bold tw-text-[20px] tw-overflow-hidden"
                        >
                            IMG_2023123123123.JPG
                        </div>
                        <div class="tw-w-[20%] tw-text-right">
                            <i class="fa fa-file"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr />
        <div class="tw-mb-6">
            <div>
                <input type="checkbox" class="tw-mr-3" />
                <span
                    >I confirm that the details presented above are accurate and
                    correct.</span
                >
            </div>
            <div>
                <input type="checkbox" class="tw-mr-3" />
                <span
                    >I confirm that I have read and agree to the terms presented
                    in the Terms and Conditions agreement.</span
                >
            </div>
        </div>
    </div>
</template>
